/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Show_Marker_Comments_HelpInputs */

const en_options_editor_show_marker_comments_help = /** @type {(inputs: Options_Editor_Show_Marker_Comments_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show marker comments in timeline.`)
};

const fr_options_editor_show_marker_comments_help = /** @type {(inputs: Options_Editor_Show_Marker_Comments_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher les commentaires des marqueurs dans la timeline.`)
};

const de_options_editor_show_marker_comments_help = /** @type {(inputs: Options_Editor_Show_Marker_Comments_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markerkommentare in der Zeitleiste anzeigen.`)
};

const it_options_editor_show_marker_comments_help = /** @type {(inputs: Options_Editor_Show_Marker_Comments_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostra i commenti dei marcatori nella cronologia.`)
};

const ru_options_editor_show_marker_comments_help = /** @type {(inputs: Options_Editor_Show_Marker_Comments_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отображать комментарии к маркерам на временной шкале.`)
};

const es_options_editor_show_marker_comments_help = /** @type {(inputs: Options_Editor_Show_Marker_Comments_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar comentarios de marcadores en la línea de tiempo.`)
};

const zh_cn2_options_editor_show_marker_comments_help = /** @type {(inputs: Options_Editor_Show_Marker_Comments_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在时间轴中显示标记注释。`)
};

const ja_options_editor_show_marker_comments_help = /** @type {(inputs: Options_Editor_Show_Marker_Comments_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムラインにマーカーコメントを表示します。`)
};

const hi_options_editor_show_marker_comments_help = /** @type {(inputs: Options_Editor_Show_Marker_Comments_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइमलाइन में मार्कर टिप्पणियां दिखाएं।`)
};

const pt_pt2_options_editor_show_marker_comments_help = /** @type {(inputs: Options_Editor_Show_Marker_Comments_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exibir comentários dos marcadores na linha do tempo.`)
};

/**
* | output |
* | --- |
* | "Show marker comments in timeline." |
*
* @param {Options_Editor_Show_Marker_Comments_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_show_marker_comments_help = /** @type {((inputs?: Options_Editor_Show_Marker_Comments_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Show_Marker_Comments_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_show_marker_comments_help(inputs)
	if (locale === "de") return de_options_editor_show_marker_comments_help(inputs)
	if (locale === "it") return it_options_editor_show_marker_comments_help(inputs)
	if (locale === "ru") return ru_options_editor_show_marker_comments_help(inputs)
	if (locale === "es") return es_options_editor_show_marker_comments_help(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_show_marker_comments_help(inputs)
	if (locale === "ja") return ja_options_editor_show_marker_comments_help(inputs)
	if (locale === "hi") return hi_options_editor_show_marker_comments_help(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_show_marker_comments_help(inputs)
	return en_options_editor_show_marker_comments_help(inputs)
});